import { getIsOrderManager, getRegionByCookie, isProd } from '@RootCommon/utils'
import { commonRequest, commonRequestAll } from '@/common/api'

const isOrderManager = getIsOrderManager()
const urlSearchParams = new URLSearchParams(location.search)
const hideToast = urlSearchParams.get('hideToast') === '1'

commonRequest.interceptors.request.use(function (config) {
  const res = {
    ...config,
    headers: {
      region: getRegionByCookie(),
      opCenterSelectedRegion: getRegionByCookie(),
      ...config.headers,
    },
  }

  if (isProd() && (isOrderManager || hideToast)) {
    res.headers.autoToast = false
  }
  return res
})

export { commonRequest, commonRequestAll }
